import { DealerDMSID, DealerLocationDMSID } from "./Dms";

export type OnlineAuthID = number;

export enum API_KEY_TYPES {
  ExactOnline = 1,
  DMS = 2
}

export interface OnlineAuth {
  created_on: string;
  updated_on: string;
  id: OnlineAuthID;
  api_key_type: API_KEY_TYPES; // Type of the API key, distinguishes the different external APIs'
  dealer_dms_id: DealerDMSID | null; // Connected dealer dms identifier
  dealer_location_dms_id: DealerLocationDMSID | null; // Connected dealer location dms identifier
  access_token: string; // Current OAUTH access token
  refresh_token: string; // Current OAUTH refresh token
  expires_at: string; // When the current OAUTH access token expires
  blocked_until: string | null; // Until when the API key is blocked (API limit reached)
}
